/**
 * Builder main gallery: prev/next buttons off — arrow cursors on left/right halves;
 * tap/click without dragging goes previous / next (Flickity swipe unchanged).
 * Hit target is [data-media-viewer] (full aspect-ratio main media box), not only .flickity-viewport / the bitmap.
 */
(function () {
  "use strict";

  const COARSE =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(pointer: coarse)").matches;

  const REDUCE_MOTION =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function slideCount(flk) {
    try {
      if (flk.slides && flk.slides.length) return flk.slides.length;
      if (flk.cells && flk.cells.length) return flk.cells.length;
    } catch (_) {}
    return 0;
  }

  function bindHalfNav(viewport, flk) {
    if (!viewport || !flk || viewport.dataset.wbHalfNavBound === "1") return;
    viewport.dataset.wbHalfNavBound = "1";

    function updateCursor(clientX) {
      if (COARSE) return;
      const n = slideCount(flk);
      if (n <= 1) {
        viewport.classList.remove("wb-gallery-cursor--prev", "wb-gallery-cursor--next");
        return;
      }
      const rect = viewport.getBoundingClientRect();
      const x = clientX - rect.left;
      const left = x < rect.width * 0.5;
      viewport.classList.toggle("wb-gallery-cursor--prev", left);
      viewport.classList.toggle("wb-gallery-cursor--next", !left);
    }

    function clearCursor() {
      viewport.classList.remove("wb-gallery-cursor--prev", "wb-gallery-cursor--next");
    }

    if (!COARSE && !REDUCE_MOTION) {
      viewport.addEventListener(
        "mousemove",
        function (e) {
          updateCursor(e.clientX);
        },
        { passive: true }
      );
      viewport.addEventListener("mouseleave", clearCursor, { passive: true });
    }

    function shouldIgnoreTarget(target) {
      if (!target || !target.closest) return false;
      return !!target.closest(
        "button, a[href], input, textarea, select, [role='button'], video, model-viewer, .shopify-model-viewer-ui, .f-video__play, [data-shopify-xr]"
      );
    }

    function goFromClientX(clientX) {
      if (slideCount(flk) <= 1) return;
      const rect = viewport.getBoundingClientRect();
      const x = clientX - rect.left;
      if (x < rect.width * 0.5) flk.previous();
      else flk.next();
    }

    let downX;
    let downY;
    let downT;

    viewport.addEventListener(
      "pointerdown",
      function (e) {
        if (e.pointerType === "mouse" && e.button !== 0) return;
        downX = e.clientX;
        downY = e.clientY;
        downT = Date.now();
      },
      true
    );

    viewport.addEventListener(
      "click",
      function (e) {
        if (shouldIgnoreTarget(e.target)) return;
        if (slideCount(flk) <= 1) return;
        if (downX == null || downY == null) return;
        const dist = Math.abs(e.clientX - downX) + Math.abs(e.clientY - downY);
        const dt = Date.now() - (downT || 0);
        downX = null;
        downY = null;
        if (dist > 16) return;
        if (dt > 900) return;
        goFromClientX(e.clientX);
      },
      true
    );
  }

  function tryInitFlickity(fc, hitZone) {
    const flk = fc.slider && fc.slider.instance;
    if (!flk || !hitZone) return false;
    bindHalfNav(hitZone, flk);
    return true;
  }

  function initGallery(gallery) {
    const viewer = gallery.querySelector(".f-product__media-viewer--carousel");
    if (!viewer) return;
    const fc = viewer.querySelector("flickity-component.f-product__media-list.wheelbuilder-gallery-hover-nav");
    if (!fc) return;
    const hitZone = viewer.querySelector("[data-media-viewer]") || fc.querySelector(".flickity-viewport");

    if (tryInitFlickity(fc, hitZone)) return;

    const mo = new MutationObserver(function () {
      if (tryInitFlickity(fc, hitZone)) mo.disconnect();
    });
    mo.observe(fc, { attributes: true, attributeFilter: ["class"], subtree: true });

    let tries = 0;
    const id = window.setInterval(function () {
      if (tryInitFlickity(fc, hitZone) || ++tries > 50) {
        window.clearInterval(id);
        mo.disconnect();
      }
    }, 100);
  }

  function run() {
    document.querySelectorAll(".wheelbuilder-product-gallery").forEach(initGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
